import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NoAccess } from '@/components/custom/no-access';
import { useMe } from '@/lib/me';

// Layout for /customers/* — list + detail nest under a common parent. Gates
// every child on `customer.view`.
export const Route = createFileRoute('/_authenticated/customers')({
  component: CustomersLayout,
});

function CustomersLayout() {
  const { permissions, loading } = useMe();
  if (!loading && !permissions.has('customer.view')) {
    return <NoAccess permission="customer.view" resource="Customers" />;
  }
  return <Outlet />;
}
